import { Component, OnInit } from '@angular/core';
import { EnvironmentService } from '../../../services/environment.service';
import { AuthorizationService } from '../../../services/authorization.service';
import { UserService } from '../../../services/user.service';
import { StoreService } from '../../../services/store.service';
import { Observable } from 'rxjs';

@Component({
  selector: 'app-home-header',
  templateUrl: './home-header.component.html'
})
export class HomeHeaderComponent implements OnInit {

  public menuList: Array<any>;
  public store: string;

  constructor(
    public envService: EnvironmentService,
    private authorizationService: AuthorizationService,
    private userService: UserService,
    private storeService: StoreService
  ) {
    this.menuList = null;
  }

  ngOnInit() {
    this.store = this.envService.getStore();
    this.userService.getUserDetails().subscribe(
      () => {

        Observable.forkJoin(
          this.authorizationService.getStorePermissions(),
          this.storeService.getFeatures()
        ).subscribe(
          (data) => {
            const permissions = data[0];
            const features = data[1];
            const showDashboard = (features && features.indexOf('package') !== -1);

            this.menuList = [];

            if (permissions && permissions.apis) {
              const haveApiReadAccess = (permissions.apis.read === true);
              const haveApiWriteAccess = (permissions.apis.write === true);

              this.menuList.push({
                id: 'nav-discover-api',
                title : 'discover api',
                link: '/apicloud/discoverApi',
                authorized: haveApiReadAccess
              });
              this.menuList.push({
                id: 'nav-publish-api',
                title : 'publish api',
                link: '/apicloud/publishApi',
                authorized: haveApiWriteAccess
              });
              /*this.menuList.push({
                id: 'nav-api-bundles',
                title : 'api bundles',
                active: false,
                link: '/apicloud/apiBundles'
              });*/
              this.menuList.push({
                id: 'nav-dashboard',
                title : 'dashboard',
                link: '/apicloud/dashboard/packages',
                authorized: haveApiReadAccess && showDashboard
              });
              this.menuList.push({
                id: 'nv-application',
                title : 'application',
                link: '/apicloud/applications',
                authorized: true
              });
              this.menuList.push(
                {
                  id: 'nav-how-to',
                  title : 'how to',
                  link: '/apicloud/helper',
                  authorized: haveApiReadAccess,
                  subMenus: [
                    {
                      id: 'nav-consumer-api-helper',
                      title : 'consume API',
                      link: '/apicloud/helper/consumeApi',
                      authorized: haveApiReadAccess
                    },
                    {
                      id: 'nav-publish-api-helper',
                      title : 'publish API',
                      link: '/apicloud/helper/publishApi',
                      authorized: permissions.apis.write
                    }
                  ]
                }
              );
            }
          }
        );
      }
    );
  }
}



// WEBPACK FOOTER //
// C:/Users/sthanga1/Documents/apicloud-x/apicloud-x/apim-ui-newgen/src/app/core/modules/header/home-header/home-header.component.ts